export class EstadoCivil {
    id: string = "0";
    descripcion: string = "";
}
